import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForAssetTokenConfigComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'headline', 'cmsState', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'headline',
      isMainColumn: true,
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
